export default __webpack_public_path__ + "static/media/Gray-LinkedIn.43a0634f.svg";